export const googleSheetsSettings = {
  integrationGoogleSheets: false,
  integrationGoogleSheetsAuth: undefined,
  integrationGoogleSheetsId: undefined,
  integrationGoogleSheetsTitle: undefined
};

export type GoogleSheetsSettings = typeof googleSheetsSettings;
